import React from 'react';
import './Sidebar.css';
import { useMobileNav } from '../../contexts/MobileNavContext';

const Sidebar = ({ activeTab, onTabChange, userRole }) => {
    const { isSidebarOpen, closeSidebar } = useMobileNav();

    const tabs = [
        {
            id: 'profile',
            label: 'Profile Information',
            icon: (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                </svg>
            )
        },
        {
            id: 'location',
            label: 'Location',
            icon: (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                </svg>
            )
        }
    ];

    // Add healer-specific tabs if user is a healer
    if (userRole === 'healer') {
        tabs.push(
            {
                id: 'services',
                label: 'Services Offered',
                icon: (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z" />
                    </svg>
                )
            },
            {
                id: 'availability',
                label: 'Appointment Slots',
                icon: (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z" />
                    </svg>
                )
            }
        );
    }

    // Add appointment and message tabs for all users
    tabs.push(
        {
            id: 'appointments',
            label: 'Appointments',
            icon: (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z" />
                </svg>
            )
        },
        // Only show Ratings tab for healers
        ...(userRole === 'healer' ? [
            {
                id: 'reviews',
                label: 'Reviews',
                icon: (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                    </svg>
                )
            }
        ] : []),
        {
            id: 'messages',
            label: 'Messages',
            icon: (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z" />
                </svg>
            )
        }
    );

    const handleTabClick = (tabId) => {
        onTabChange(tabId);
        // Close mobile menu when a tab is clicked
        closeSidebar();
    };

    return (
        <>
            {/* Mobile Menu Overlay */}
            {isSidebarOpen && (
                <div
                    className="mobile-menu-overlay"
                    onClick={closeSidebar}
                ></div>
            )}

            <div className={`sidebar ${isSidebarOpen ? 'mobile-open' : ''}`}>
                <div className="sidebar-header">
                    <h3>Dashboard</h3>
                    <p>Manage your account</p>
                </div>

                {/* Back to Home Link - Only show on mobile */}
                <div className="sidebar-back-link d-lg-none">
                    <a href="/home" className="back-home-link">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
                        </svg>
                        <span>Back to Home</span>
                    </a>
                </div>

                <nav className="sidebar-nav">
                    {tabs.map((tab) => (
                        <button
                            key={tab.id}
                            className={`sidebar-tab ${activeTab === tab.id ? 'active' : ''}`}
                            onClick={() => handleTabClick(tab.id)}
                        >
                            <span className="tab-icon">{tab.icon}</span>
                            <span className="tab-label">{tab.label}</span>
                        </button>
                    ))}
                </nav>
            </div>
        </>
    );
};

export default Sidebar; 